import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=7fd9cac7&"
import script from "./Video.vue?vue&type=script&lang=js&"
export * from "./Video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QInnerLoading,QSpinnerGears}, component.options.components || {})
